<template>
    <tr>
        <td>{{ car.lot_date }}</td>
        <td>{{ car.auction_name}}</td>
        <td>{{ car.bid }}</td>
        <td>{{ car.company }}</td>
        <td>{{ car.model_name_en }}</td>
        <td>{{ car.model_type_en }}</td>
        <td>{{ car.model_year_en }}</td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <rec-fee-column v-else :car="car"></rec-fee-column>
        </td>
        <td>{{ car.expected_exportation }}</td>
        <td>{{ recStatus }}</td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <rec-fee-applied-column v-else :car="car"></rec-fee-applied-column>
        </td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <rec-fee-refunded-column v-else :car="car"></rec-fee-refunded-column>
        </td>
    </tr>
</template>

<script>
    import RecFeeColumn from './RecFeeColumn'
    import RecFeeAppliedColumn from './RecFeeAppliedColumn'
    import RecFeeRefundedColumn from './RecFeeRefundedColumn'
    export default {
        props: ['car'],
        components: {
            RecFeeColumn,
            RecFeeAppliedColumn,
            RecFeeRefundedColumn
        },
        computed: {
            recStatus() {
                if (this.car.rec_fee_refunded) {
                    return 'Refunded'
                } else if (this.car.rec_fee_applied) {
                    return 'Applied'
                } else  {
                    return 'Not applied'
                }
            },
            isLoading() {
                return this.$store.getters.getLoaderStatus
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/RecFee/RecFeeTableRow.vue